// 二级品牌馆配置 长沙学院
export default {
  'yinhe.ubanquan.cn': {
    // 主应用二级品牌馆id映射
    development: {
      storeNo: 'ST788802694800001648015011',
      storeName: '银河馆',
      microHost: 'yinhe-brand.ubanquan.cn'
    },
    test: {
      storeNo: 'ST788802694800001648015011',
      storeName: '银河馆',
      microHost: 'yinhe-brand.ubanquan.cn'
    },
    realpre: {
      storeNo: 'ST788802694800001648015011',
      storeName: '银河馆',
      microHost: 'yinhe-brand.ubanquan.cn'
    },
    production: {
      storeNo: 'ST788802694800001648015011',
      storeName: '银河馆',
      microHost: 'yinhe-brand.ubanquan.cn'
    }
  }
};